export function isLeafGate(gate) {
    return gate.kind !== "composite_gate";
}
export function shouldPreprocessGate(gate) {
    return [
        // "unique_person_gate" omitted - DecideAI verification is suspended
        "credential_gate",
        "payment_gate",
        "lifetime_diamond_gate",
        "diamond_gate",
    ].includes(gate.kind);
}
export function isLocked(gate) {
    if (gate === undefined)
        return false;
    if (isCompositeGate(gate)) {
        switch (gate.operator) {
            case "and":
                return gate.gates.some(isLockedGate);
            case "or":
                return gate.gates.every(isLockedGate);
        }
    }
    else {
        return isLockedGate(gate);
    }
}
function isLockedGate(gate) {
    return gate.kind === "locked_gate";
}
export function isCompositeGate(gate) {
    return gate.kind === "composite_gate";
}
export function isNeuronGate(gate) {
    return gate.kind === "neuron_gate";
}
export function isPaymentGate(gate) {
    return gate.kind === "payment_gate";
}
export function isBalanceGate(gate) {
    return gate.kind === "token_balance_gate";
}
export function isChitEarnedGate(gate) {
    return gate.kind === "chit_earned_gate";
}
export function isCredentialGate(gate) {
    return gate.kind === "credential_gate";
}
export function isUniquePersonGate(gate) {
    return gate.kind === "unique_person_gate";
}
// The unique person ("verified user", DecideAI) concept is suspended. For display purposes we
// strip any unique person gate so that a standalone unique person gate looks like no gate, and a
// composite gate drops it (collapsing to the single remaining gate, or no gate if none remain).
export function stripSuspendedGate(gate) {
    if (isUniquePersonGate(gate)) {
        return { kind: "no_gate" };
    }
    if (isCompositeGate(gate)) {
        const remaining = gate.gates.filter((g) => !isUniquePersonGate(g));
        if (remaining.length === 0) {
            return { kind: "no_gate" };
        }
        if (remaining.length === 1) {
            return remaining[0];
        }
        return { ...gate, gates: remaining };
    }
    return gate;
}
export function isLifetimeDiamondGate(gate) {
    return gate.kind === "lifetime_diamond_gate";
}
export function isDiamondGate(gate) {
    return gate.kind === "diamond_gate";
}
export function defaultChatRules(level) {
    let text = "";
    if (level !== "channel") {
        text = `- Do not impersonate others in a deceptive or misleading manner
- Do not intentionally share false or misleading information
- Keep messages relevant to the ${level === "community" ? "channel" : "group"}

If you break the rules you might be blocked and/or have your message(s) deleted.`;
    }
    return {
        text,
        enabled: false,
        version: 0,
    };
}
